import { render, staticRenderFns } from "./dataview.vue?vue&type=template&id=7de2f1fa&scoped=true&"
import script from "./dataview.vue?vue&type=script&lang=js&"
export * from "./dataview.vue?vue&type=script&lang=js&"
import style0 from "./dataview.vue?vue&type=style&index=0&id=7de2f1fa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de2f1fa",
  null
  
)

export default component.exports